import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "@/assets/logo.svg";

const LINKS = [
  { to: "/services", label: "Services", hash: false },
  { to: "/apps", label: "Apps", hash: false },
  { to: "/about", label: "About", hash: false },
  { to: "/faq", label: "FAQ", hash: false },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => setOpen(false);

  return (
    <header className={`nav${scrolled ? " is-scrolled" : ""}${open ? " is-open" : ""}`} id="nav">
      <div className="nav__inner">
        <Link className="brand" to="/" onClick={close} aria-label="IT-Patrol home">
          <img className="brand__mark" src={logo} width="40" height="40" alt="" />
          <span>
            <span className="brand__name">IT-Patrol</span>
            <span className="brand__tag">Dev &amp; consulting</span>
          </span>
        </Link>

        <nav aria-label="Primary">
          <ul className="nav__links" id="nav-links">
            {LINKS.map((link) => (
              <li key={link.to}>
                {link.hash ? (
                  <a href={link.to} onClick={close}>
                    {link.label}
                  </a>
                ) : (
                  <NavLink to={link.to} onClick={close}>
                    {link.label}
                  </NavLink>
                )}
              </li>
            ))}
            <li>
              <Link className="nav__cta" to="/contact" onClick={close}>
                Start a project
              </Link>
            </li>
          </ul>
        </nav>

        <button
          className="nav__toggle"
          type="button"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span />
        </button>
      </div>
    </header>
  );
}
